module.exports = __webpack_public_path__ + "static/media/alfonso boton.b55eaf1a.png";